/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description mutate hook to post code tenant data
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

const usePostCodeTenantData = (): UseMutationResult<unknown, IAxiosError, CodeExplorer.IPostCodeTenantData, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.CodeExplorerTenantDataApi.postCodeTenantData({ postCodeTenantDataModel: model });
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.codeTenantData] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default usePostCodeTenantData;
